import * as zod from 'zod'

// TODO: worth trying to use https://github.com/fabien0102/ts-to-zod?

const title = zod
  .string()
  .trim()
  .min(1)
  .max(128)

const report = zod.string().trim().max(9000, {message: "That's over 9000!"})

const happened = zod.date()

const tags = zod.array(zod.object({
  value: zod.string(),
  label: zod.string(),
}))

const coverId = zod.object({
  value: zod.number(),
  label: zod.object({}),
}).nullable()

const start = zod.date().nullable()

const end = zod.date().nullable()

const tripId = zod.number()

const token = zod.string().trim().min(1)

const priorId = zod.object({
  value: zod.number(),
  label: zod.string(),
}).nullable()

const parentId = zod.object({
  value: zod.number(),
  label: zod.string(),
}).nullable()

export const AddTripSchema = zod.object({title, report, happened, tags})
export type AddTripSchema = zod.infer<typeof AddTripSchema>

export const UpdateTripSchema = zod.object({title, report, happened, tags, coverId, priorId, parentId})
export type UpdateTripSchema = zod.infer<typeof UpdateTripSchema>

export const FilterTripsSchema = zod.object({start, end, tags})
export type FilterTripsSchema = zod.infer<typeof FilterTripsSchema>

export const SelectTripSchema = zod.object({tripId})
export type SelectTripSchema = zod.infer<typeof SelectTripSchema>

export const PublicTripSchema = zod.object({token})
export type PublicTripSchema = zod.infer<typeof PublicTripSchema>
